'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dRegister$002dPage$002dView$0024$0024anon$002418 from "./presto.-Register-Page-View$$anon$18.js";
import * as $j_presto$002e$002dRegister$002dPage$002dView$0024$0024anon$00244 from "./presto.-Register-Page-View$$anon$4.js";
import * as $j_presto$002etypes$0024$002dSingle$002dApp$002dToken$0024 from "./presto.types$-Single-App-Token$.js";
var $p;
/** @constructor */
function $c_Lpresto_RegisterPageView$$anon$3(outer) {
  this.bu9 = null;
  this.bu1 = null;
  this.bu2 = false;
  this.bua = null;
  this.bub = false;
  this.bue = null;
  this.bu7 = null;
  this.bu8 = false;
  this.bu3 = null;
  this.bu4 = false;
  this.bu5 = null;
  this.bu6 = false;
  this.buc = false;
  this.bud = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.bu9 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bue = "SingleAppToken";
}
export { $c_Lpresto_RegisterPageView$$anon$3 as $c_Lpresto_RegisterPageView$$anon$3 };
$p = $c_Lpresto_RegisterPageView$$anon$3.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_RegisterPageView$$anon$3;
/** @constructor */
function $h_Lpresto_RegisterPageView$$anon$3() {
}
export { $h_Lpresto_RegisterPageView$$anon$3 as $h_Lpresto_RegisterPageView$$anon$3 };
$h_Lpresto_RegisterPageView$$anon$3.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.bu9;
});
$p.L = (function() {
  if ((!this.bu2)) {
    this.bu1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bu2 = true;
  }
  return this.bu1;
});
$p.O = (function() {
  if ((!this.bub)) {
    this.bua = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bub = true;
  }
  return this.bua;
});
$p.E = (function() {
  return this.bue;
});
$p.t = (function() {
  if ((!this.bu8)) {
    this.bu7 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("created", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("expires", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("user", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.bu8 = true;
  }
  return this.bu7;
});
$p.M = (function() {
  if ((!this.bu4)) {
    this.bu3 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().Gu(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().Gu())), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dRegister$002dPage$002dView$0024$0024anon$00244.$c_Lpresto_RegisterPageView$$anon$4(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))));
    this.bu4 = true;
  }
  return this.bu3;
});
$p.Q = (function() {
  if ((!this.bu6)) {
    this.bu5 = new $j_presto$002e$002dRegister$002dPage$002dView$0024$0024anon$002418.$c_Lpresto_RegisterPageView$$anon$18();
    this.bu6 = true;
  }
  return this.bu5;
});
$p.w = (function() {
  if ((!this.bud)) {
    this.buc = false;
    this.bud = true;
  }
  return this.buc;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee121) => ((p) => \u03b4scrutinee121.ade(p)))($j_presto$002etypes$0024$002dSingle$002dApp$002dToken$0024.$m_Lpresto_types$SingleAppToken$())));
});
var $d_Lpresto_RegisterPageView$$anon$3 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_RegisterPageView$$anon$3, "presto.RegisterPageView$$anon$3", ({
  Q2: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_RegisterPageView$$anon$3 as $d_Lpresto_RegisterPageView$$anon$3 };
//# sourceMappingURL=presto.-Register-Page-View$$anon$3.js.map
